/**
 * 高德 JS API 2.0：必须在加载 maps 脚本之前设置安全密钥。
 * @see https://lbs.amap.com/api/javascript-api-v2/getting-started
 *
 * 本文件不得 import @amap/amap-jsapi-loader，且应在 main.js 中最先 import，
 * 保证早于任何会触发 AMapLoader.load 的代码。
 */
const raw = process.env.VUE_APP_AMAP_SECURITY_JS_CODE
const code = typeof raw === 'string' ? raw.trim() : ''

if (typeof window !== 'undefined' && code) {
  window._AMapSecurityConfig = Object.assign({}, window._AMapSecurityConfig || {}, {
    securityJsCode: code
  })
}
